/** A title into an address or a field key: lowercase words joined by hyphens, as the database requires. */
export function slugify(title: string): string {
  return title
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 120);
}

/** A field key: the same, with underscores, because a key is used in code and in a submission's answers. */
export function fieldKey(label: string): string {
  const key = slugify(label).replace(/-/g, "_").slice(0, 40);
  return /^[a-z]/.test(key) ? key : `field_${key}`.slice(0, 40);
}
